import Subtitle from './Subtitle';
import withHtmlSafe from '../withHtmlSafe';
export default withHtmlSafe(Subtitle);